import { render, staticRenderFns } from "./SchoolGrid.vue?vue&type=template&id=1a6cdee6&scoped=true"
import script from "./SchoolGrid.vue?vue&type=script&lang=js"
export * from "./SchoolGrid.vue?vue&type=script&lang=js"
import style0 from "./SchoolGrid.vue?vue&type=style&index=0&id=1a6cdee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6cdee6",
  null
  
)

export default component.exports